export default __webpack_public_path__ + "static/media/iiitk_logo.27484d2c.png";